import { call, put, takeEvery } from "redux-saga/effects"

// Crypto Redux States
import { GET_TASKS, POST_TASKS } from "./actionTypes"
import { getTasksSuccess, getTasksFail } from "./actions"

//Include Both Helper File with needed methods
import { getTasks, postCreateTask } from "helpers/fakebackend_helper"

function* fetchTasks() {
  try {
    const response = yield call(getTasks)
    yield put(getTasksSuccess(response))
  } catch (error) {
    yield put(getTasksFail(error))
  }
}

function* CreateTask() {
  try {
    const response = yield call(postCreateTask)
    yield put(getTasksSuccess(response))
  } catch (error) {
    yield put(getTasksFail(error))
  }
}

function* tasksSaga() {
  yield takeEvery(GET_TASKS, fetchTasks)
  yield takeEvery(POST_TASKS, CreateTask)
}

export default tasksSaga
